import { css } from 'styled-components';
import { NumberAttr } from './types';

export const getWidth = (col: NumberAttr) => {
  if (col === 'hidden') {
    return css`
      display: none;
    `;
  }
  return css`
    width: calc(100% * ${col} / 12);
    display: unset;
  `;
};
